import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { NavigationTile } from '@skatteetaten/ds-navigation';
import { Alert } from '@skatteetaten/ds-status';
import { RolePickerContext } from '../RolePickerContext/index.esm.js';
import './styles.css';


var styles = {
    "withAlert": "RolePickerRow-module_withAlert__DxPmf"
};

function RolePickerRow({ id, title, description, svgPath, titleAs, onClick }) {
    const ctx = useContext(RolePickerContext);
    const hasError = ctx?.error?.entityId === id;
    return /*#__PURE__*/ jsxs("div", {
        children: [
            /*#__PURE__*/ jsx(NavigationTile, {
                href: '#',
                className: `${hasError ? styles.withAlert : ''}`,
                titleAs: titleAs ?? 'h3',
                title: title,
                svgPath: svgPath,
                hasSpinner: ctx?.loadingEntityId === id,
                size: 'medium',
                description: description,
                onClick: async (e)=>{
                    e.preventDefault();
                    onClick?.(e);
                }
            }),
            /*#__PURE__*/ jsx(Alert, {
                variant: 'neutral',
                showAlert: hasError,
                onClose: ()=>ctx?.setError(undefined),
                children: ctx?.error?.message
            })
        ]
    });
}
RolePickerRow.displayName = 'RolePickerRow';

export { RolePickerRow };
